export {};

const ANCHOR_SELECTOR = '.js-modal-html-gallery__anchor';

let isOpen = false;
let isUpdating = false;

$(document).on('click', '.modal__direction', function(evt) {
    if (!isUpdating) {
        const isRight = $(this).hasClass('modal__direction--next');

        if ($.magnificPopup.instance.isOpen) {
            isUpdating = true;

            isRight ? $.magnificPopup.instance.next() : $.magnificPopup.instance.prev();
        }
    }

    evt.preventDefault();
});

$(document).on('click', ANCHOR_SELECTOR, function(evt) {
    const $anchor = $(this);
    const $item = $anchor.closest('.js-modal-html-gallery__item');
    const $items = $item.parent().children();
    const $anchors = $items.find(ANCHOR_SELECTOR);

    const index = $item.index();
    const items = [];

    $anchors.each((anchorIdx, Anchor) => {
        items.push({
            src: Anchor.href,
        });
    });

    if ($.magnificPopup.instance.isOpen) {
        $.magnificPopup.close();

        setTimeout(openModal, NLMK.magnificPopupDefaults.zoom.duration);
    } else {
        openModal();
    };
    setTimeout(() => {
        const $btns = $('.modal__direction')

        if ($('.js-modal-html-gallery__item').length <= 1) {
            $btns.hide()
            console.log($btns)
        }
    }, 33);

    function openModal() {
        /* eslint-disable */
        $.magnificPopup.open({
            items,
            type: 'ajax',
            ...NLMK.magnificPopupDefaults,
            mainClass: 'mfp-fade mfp-with-zoom mfp-ajax-gallery',
            gallery: {
                enabled: true,
                preload: [0, 2],
            },
            callbacks: {
                parseAjax: function(mfpResponse) {
                    if (typeof mfpResponse.data.html !== 'undefined') {
                        mfpResponse.data = mfpResponse.data.html;
                    }
                },
                open() {
                    isOpen = true;
                },
                close() {
                    isOpen = false;
                },
                afterChange() {
                    isUpdating = false;

                    setTimeout(() => {
                        if (innerWidth < NLMK.mediaQueries.horizontalTablet.min) {
                            this.wrap[0].scrollTop = 0;
                        }
                    }, 300);
                },
            },
        }, index);
    }

    evt.preventDefault();
});



// WEBPACK FOOTER //
// ./js/main/module/modal-html-gallery.js